import { ADMIN_ROUTING } from "./admin-routing";

const REPORTS_ROUTING = {
  FLEET: {
    COUNTERS: `/dashboard/reports/fleet/counters`,
    PRE_FLIGHTS: {
      CONFIGURE: `/dashboard/reports/pre-flights/configure`,
      ROOT: `/dashboard/reports/pre-flights`,
      VIEW: `/dashboard/reports/pre-flights/view`,
    },
    ROOT: `/dashboard/reports/fleet`,
    W_AND_B: `/dashboard/reports/fleet/w-and-b`,
  },
  ROOT: `/dashboard/reports`,
} as const;

/** Deprecated `/dashboard/administration/reports/*` paths kept for redirects. */
const LEGACY_ADMINISTRATION_REPORTS_ROUTING = {
  FLEET: {
    COUNTERS: `/dashboard/administration/reports/fleet/counters`,
    PRE_FLIGHTS: {
      CONFIGURE: `/dashboard/administration/reports/pre-flights/configure`,
      ROOT: `/dashboard/administration/reports/pre-flights`,
      VIEW: `/dashboard/administration/reports/pre-flights/view`,
    },
    ROOT: `/dashboard/administration/reports/fleet`,
    W_AND_B: `/dashboard/administration/reports/fleet/w-and-b`,
  },
  ROOT: `/dashboard/administration/reports`,
} as const;

const REPORTS_ROUTES = [
  REPORTS_ROUTING.ROOT,
  REPORTS_ROUTING.FLEET.ROOT,
  REPORTS_ROUTING.FLEET.COUNTERS,
  REPORTS_ROUTING.FLEET.W_AND_B,
  REPORTS_ROUTING.FLEET.PRE_FLIGHTS.ROOT,
  REPORTS_ROUTING.FLEET.PRE_FLIGHTS.VIEW,
  REPORTS_ROUTING.FLEET.PRE_FLIGHTS.CONFIGURE,
  ADMIN_ROUTING.REPORTS.ROOT,
  ADMIN_ROUTING.REPORTS.FLEET.PRE_FLIGHTS.ROOT,
  ADMIN_ROUTING.REPORTS.FLEET.W_AND_B,
] as const;

export {
  LEGACY_ADMINISTRATION_REPORTS_ROUTING,
  REPORTS_ROUTES,
  REPORTS_ROUTING,
};
